import React, { useEffect, useState } from "react";
import axios from "axios";
import teamService from "../Services/TeamService";
import LeadDbService from "../Services/LeadDbService";


function formatNumber(num) {
  // if (num >= 1e7) {
  //   return (num / 1e7).toFixed(2).replace(/\.0$/, "") + "C";
  // }
  // if (num >= 1e5) {
  //   return (num / 1e5).toFixed(2).replace(/\.0$/, "") + "L";
  // }
  if (num >= 1e6) {
    return (num / 1e6).toFixed(2).replace(/\.0$/, "") + "M";
  }
  if (num >= 1e3) {
    return (num / 1e3).toFixed(2).replace(/\.0$/, "") + "K";
  }
  return num.toString();
}

const ProgressBar = ({ data }) => {
  return (
    <div className="container mx-auto px-5 h-[650px] overflow-y-auto custom-scrollbar py-8">
      {data.map((item, itemIndex) => {
        let accumulatedWidth = 0;
        return (
          <div key={itemIndex} className="flex gap-4 px-4 items-center mb-8">
            <h2
             title={item.heading}
             className=" cursor-pointer text-lg font-semibold w-7/12 text-left whitespace-nowrap xl:truncate 4xl:text-2xl ">
              {item.heading}
            </h2>
            <div className="bg-gray-200 h-3 w-[2400px] xl:w-[1300px] relative">
              {item.segments.map((segment, segmentIndex) => {
                const segmentWidth = `${
                  (segment.value / item.totalValue) * 100
                }%`;
                const segmentStyle = {
                  width: segmentWidth,
                  left: `${accumulatedWidth}%`,
                  backgroundColor: segment.color,
                };
                accumulatedWidth += (segment.value / item.totalValue) * 100;
                return (
                  <div
                    key={segmentIndex}
                    className="tooltip "
                    style={segmentStyle}
                  >
                    <div className=" tooltiptext">
                      {segment.tooltipText}
                    </div>
                  </div>
                );
              })}
            </div>

            <h2 className="text-lg font-semibold w-5/12 text-center  4xl:text-2xl">
              {formatNumber(item.totalValue)}
            </h2>
          </div>
        );
      })}
    </div>
  );
};

const TeamWise = ({ selectedTeam }) => {
  const [data, setData] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const role = userData?.user?.role;
  const bodTeamId = userData?.teamId?.[0]?.id;



  useEffect(() => {
    const fetchData = async () => {
      try {
        let formattedData = [];

        if (role === "Admin" || role === "CMO") {
          const teamsResponse = await teamService.getTeamName();
          const teamIds = teamsResponse.data?.teams.map((team) => team.teamId);
          const promises = teamIds.map((id) => LeadDbService.fetchLeadsByTeam(id));
          const responses = await Promise.all(promises);

          formattedData = responses.map((response) => {
            const teamData = response.data;
            const totalValue = teamData.freshLeadCount +
              teamData.interestedLeadCount +
              teamData.dealingLeadCount +
              teamData.customerLeadCount +
              teamData.dealLostLeadCount +
              teamData.retrySuitableLeadCount +
              teamData.notInterestedLeadCount;
            return {
              heading: teamData.name,
              totalValue: totalValue,
              segments: [
                {
                  key: "Fresh",
                  value: teamData.freshLeadCount,
                  color: "#678FDC",
                  tooltipText: `Fresh: ${teamData.freshLeadCount}`,
                },
                {
                  key: "Interest, Dealing, Customer",
                  value: teamData.interestedLeadCount +
                    teamData.dealingLeadCount +
                    teamData.customerLeadCount,
                  color: "#399E79",
                  tooltipText: `Interest, Dealing, Customer: ${
                    teamData.interestedLeadCount +
                    teamData.dealingLeadCount +
                    teamData.customerLeadCount
                  }`,
                },
                {
                  key: "Deal Lost, Not Interested, Retry Suitable",
                  value: teamData.dealLostLeadCount +
                    teamData.notInterestedLeadCount +
                    teamData.retrySuitableLeadCount,
                  color: "#EE6C4D",
                  tooltipText: `Deal Lost, Not Interested, Retry Suitable: ${
                    teamData.dealLostLeadCount +
                    teamData.notInterestedLeadCount +
                    teamData.retrySuitableLeadCount
                  }`,
                },
              ],
            };
          });

        } else if (role === "MD") {
          const response = await LeadDbService.fetchLeadCountByTeam(selectedTeam);
          const teamData = response.data;

          formattedData = teamData.membersList.map((member) => {
            const totalValue = member.freshLeadCount +
              member.interestedLeadCount +
              member.dealingLeadCount +
              member.customerLeadCount +
              member.dealLostLeadCount +
              member.retrySuitableLeadCount +
              member.notInterestedLeadCount;
            return {
              heading: member.name,
              totalValue: totalValue,
              segments: [
                {
                  key: "Fresh",
                  value: member.freshLeadCount,
                  color: "#678FDC",
                  tooltipText: `Fresh: ${member.freshLeadCount}`,
                },
                {
                  key: "Interest, Dealing, Customer",
                  value: member.interestedLeadCount +
                    member.dealingLeadCount +
                    member.customerLeadCount,
                  color: "#399E79",
                  tooltipText: `Interest, Dealing, Customer: ${
                    member.interestedLeadCount +
                    member.dealingLeadCount +
                    member.customerLeadCount
                  }`,
                },
                {
                  key: "Deal Lost, Not Interested, Retry Suitable",
                  value: member.dealLostLeadCount +
                    member.notInterestedLeadCount +
                    member.retrySuitableLeadCount,
                  color: "#EE6C4D",
                  tooltipText: `Deal Lost, Not Interested, Retry Suitable: ${
                    member.dealLostLeadCount +
                    member.notInterestedLeadCount +
                    member.retrySuitableLeadCount
                  }`,
                },
              ],
            };
          });

        } else if (role === "BOD") {
          const response = await LeadDbService.fetchLeadCountByTeam(bodTeamId);
          const teamData = response.data;

          formattedData = teamData.membersList.map((member) => {
            const totalValue = member.freshLeadCount +
              member.interestedLeadCount +
              member.dealingLeadCount +
              member.customerLeadCount +
              member.dealLostLeadCount +
              member.retrySuitableLeadCount +
              member.notInterestedLeadCount;
            return {
              heading: member.name,
              totalValue: totalValue,
              segments: [
                {
                  key: "Fresh",
                  value: member.freshLeadCount,
                  color: "#678FDC",
                  tooltipText: `Fresh: ${member.freshLeadCount}`,
                },
                {
                  key: "Interest, Dealing, Customer",
                  value: member.interestedLeadCount +
                    member.dealingLeadCount +
                    member.customerLeadCount,
                  color: "#399E79",
                  tooltipText: `Interest, Dealing, Customer: ${
                    member.interestedLeadCount +
                    member.dealingLeadCount +
                    member.customerLeadCount
                  }`,
                },
                {
                  key: "Deal Lost, Not Interested, Retry Suitable",
                  value: member.dealLostLeadCount +
                    member.notInterestedLeadCount +
                    member.retrySuitableLeadCount,
                  color: "#EE6C4D",
                  tooltipText: `Deal Lost, Not Interested, Retry Suitable: ${
                    member.dealLostLeadCount +
                    member.notInterestedLeadCount +
                    member.retrySuitableLeadCount
                  }`,
                },
              ],
            };
          });
        }

        setData(formattedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [role, selectedTeam, bodTeamId]);
  return (
    <div className="  py-8 shadow-md rounded-md w-full   h-full bg-white ">
      <div className="flex justify-between gap-10 px-6 items-center">
        <h1 className="text-3xl 3xl:text-4xl font-bold mb-4 mt-2 whitespace-nowrap">
          Team Wise
        </h1>
        <div className="pr-16 float-right xl:pr-0 4xl:text-2xl">
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 rounded-full bg-[#678FDC]"></div>
            <p>Fresh</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 rounded-full bg-[#399E79]"></div>
            <p>Interest, Dealing, Customer</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 rounded-full bg-[#EE6C4D]"></div>
            <p>Deal Lost, Not Interested, Retry Suitable</p>
          </div>
        </div>
      </div>
      <ProgressBar data={data} />
    </div>
  );
};

export default TeamWise;
